import React, { useRef, useState } from 'react';
import './LayarSapa.css';

/** Set at login for subscribers so the Dashboard opens behind the Layar Sapa once. */
export const LAYAR_SAPA_PENDING = 'layarSapaPending';

/**
 * Full-screen preview of the client's Layar Sapa image. Dismisses on
 * swipe-up, click or Enter/Space, sliding up like the scanner's welcome
 * screen, then calls `onDone`.
 */
function LayarSapa({ image, onDone }) {
  const [leaving, setLeaving] = useState(false);
  const touchStartY = useRef(0);

  const dismiss = () => {
    if (leaving) return;
    setLeaving(true);
    setTimeout(onDone, 500); // matches the slide-up animation
  };

  return (
    <div
      className={`layar-sapa ${leaving ? 'layar-sapa--out' : ''}`}
      style={{ backgroundImage: `url(${image})` }}
      onTouchStart={(e) => {
        touchStartY.current = e.touches[0].clientY;
      }}
      onTouchEnd={(e) => {
        if (touchStartY.current - e.changedTouches[0].clientY > 50) dismiss();
      }}
      onClick={dismiss}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          dismiss();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Buka dashboard"
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus
    >
      <span className="layar-sapa__hint">Ketuk atau geser ke atas untuk melanjutkan</span>
    </div>
  );
}

export default LayarSapa;
